import { useQuery } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import { postAdvisorList } from "web_myplann/Infrastructure/ApiOld/Api";

export const useAdvisorsQuery = () =>
	useQuery({
		queryKey: AdvisorKeys.list(),
		queryFn: () => postAdvisorList(),
		select: (resp) =>
			resp?.status === 200 ? (resp.data?.data?.items ?? []) : [],
	});
